import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector} from 'react-redux'
import SendEvent from '../analytics'
import { selectors as errorSelectors } from '../features/error'
import { RESET_ERROR } from '../features/error/actionTypes'
import { IErrorButton } from '../features/error/types'
import { scrollToBeginning } from '../helpers'

const Error: React.FC = () => {
  const dispatch = useDispatch();
  const title = useSelector(errorSelectors.getErrorTitle);
  const text = useSelector(errorSelectors.getErrorText);
  const buttons = useSelector(errorSelectors.getErrorButtons);
  const icon = useSelector(errorSelectors.getErrorIcon);
  const show = !!title;
  const [isInit, setIsInit] = useState(false);

  const handleButtonClick = (b: IErrorButton) => {
    b.callback && b.callback();
    b.clearErrorOnClick && dispatch({ type: RESET_ERROR });
    setTimeout(() => setIsInit(false), 500);
  };
  useEffect(() =>{
    if (!isInit && show){
      setIsInit(true);
      scrollToBeginning();
      SendEvent({
        event: 'sendEvent',
        eventCategory: 'Error',
        eventAction: `Instant Offer - error`,
        eventLabel: `error - ${title}`,
        eventValue: 0,
        nonInteraction: true
      })
    }
  });
  return (
    <Fragment>
      <div className={`i-error ${show ? 'i-show' : ''}`}>
        <div className="i-con">
          {icon ? <img src={icon.default} className="i-error-icon" role="presentation" /> : ''}
          <h2>{title}</h2>
          {text ? <p>{text}</p> : ''}
          {buttons && buttons.length ? 
            <div className="i-button-group">
              {buttons.map((b,i) => <div key={i}>
                <button className={b.classes || ''} onClick={() => handleButtonClick(b)}>{b.title}</button>
              </div>)}
            </div>
          : ''}
        </div>
      </div>
    </Fragment>
  )
}

export default Error
